import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取小区公示列表
export function getCommunityPublicityList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/publicity.listCommunityPublicity',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除小区公示
export function deleteCommunityPublicity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/publicity.deleteCommunityPublicity',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'error'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

